import React from 'react';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../context/auth/ApiContext';
import { settingContext } from '../context/Setting/Setting';
import importScript from '../effect/scriptHook';
import { authGetRequest } from '../api/laravel/public/api';
import { _retrieveData } from '../utils/local-storage';
import { showMenu } from "../utils/menu-mobile.tsx";


export const MenuHooks = () => {
    const [event, setEvent] = React.useState<any>(null);
    const [inbox, setInbox] = React.useState<any>(null);
    const [user, setUser] = React.useState<any>(null);

    importScript('/theme/js/jquery-1.11.0.min.js', 'jqueryAd');
    importScript('/theme/js/bootstrap.min.js', 'boostrapAd');
    importScript('/theme/js/jquery.appear.min.js', 'jqueryApp');
    importScript('/theme/js/jquery.easing.min.js', 'jqueryEas');
    importScript('/theme/js/jquery.owl.carousel.js', 'jqueryOwl');
    importScript('/theme/js/perfect-scrollbar.min.js', 'perfectScrl');
    importScript('/theme/js/scripts.js', 'scriptJs');

    React.useEffect(() => {
        checkUser();
        eventsGet();
        getInbox();
    }, []);


    const eventsGet = async (): Promise<any> => {
        const { data_r, isError } = await authGetRequest(`/account/events`);
        setEvent(data_r);
    };

    const getInbox = async (): Promise<any> => {
        const { data_r, isError } = await authGetRequest(`/account/inbox`);
        setInbox(data_r);
    };

    const checkUser = async (): Promise<any> => {
        let userData = await _retrieveData('user_info');
        setUser(userData);
    };

    // React.useEffect(() => {
    //     const handleHtmlClick = (event: MouseEvent) => {
    //         const target = event.target as HTMLElement;
    //         const isExcluded = target.closest("section");
    //         if (isExcluded) {
    //             // Handle your logic for the click event here
    //             // console.log("clicking on excluded area")
    //             showMenu(false, undefined, "none");
    //             //  return false;
    //         }
    //     };
    //     document.querySelector('html')?.addEventListener('click', handleHtmlClick);
    //     return () => {
    //         document.querySelector('html')?.removeEventListener('click', handleHtmlClick);
    //     };
    // }, []);



    return {
        user,
        inbox,
        event,
    };
}
